<template>
  <v-dialog v-model="isVisible" scrollable persistent max-width="300px">
    <v-card>
      <v-card-title>
        <span class="headline">Select the headers</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="height: 400px">
        <v-layout row wrap>
          <v-flex v-for="(component, index) in fields" v-if="!component.hidden" :key="`${title}-${index}`" xs12 md12>
            <v-switch
              v-model="fieldState[component.param]"
              :label="component.name"
              color="indigo"
              :value="component.param"
              @change="switchState(component)"
              hide-details
            ></v-switch>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" flat @click="close">Close</v-btn>
        <v-btn color="success" flat @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    fields: Array,
    title: String,
    activeHeader: Object
  },
  data() {
    return {
      // isVisible: false,
      fieldState: {},
      headers: {}
    }
  },
  mounted() {
    this.resetState()
  },
  methods: {
    switchState(component) {
      if(this.fieldState[component.param]) {
        this.headers[component.param] = component
      } else {
        delete this.headers[component.param]
      }
    },
    save() {
      this.isVisible = false
      this.$emit('accept', Object.values(this.headers))
    },
    close() {
      this.isVisible = false
    },
    resetState() {
      this.headers = {}
      this.fields.forEach(item => {
        this.$set(this.fieldState, item.param, this.activeHeader[item.param] ? item.param : null)
        this.switchState(item)
      })
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.show
      },
      set(value) {
        this.$emit('stateChange', value)
      }
    }
  },
  watch: {
  //   show() {
  //     this.isVisible = this.show
  //   },
  //   isVisible() {
  //     this.$emit('stateChange', this.isVisible)
  //   },
    fields() {
      this.fieldState = {}
      this.resetState()
    },
    activeHeader() {
      this.resetState()
    }
  }
}
</script>

<style></style>